import {
  useEditMaterial as useDomainEditMaterial,
  MaterialsQueryKey,
  MaterialWithRecipesQueryKey
} from '@domain/materials'
import {useNotification} from '@hconnect/uikit/src/common'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {settingsQueryClient} from '../../../../modules/common/providers'
import {notifyIfErrorMessage} from '../../../../modules/common/utils/errorHandling'
import {ErrorResponse} from '../../../common/types'

export const useEditMaterial = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()
  return useDomainEditMaterial({
    onError: (error) => {
      notifyIfErrorMessage(
        (error.response?.data as ErrorResponse | undefined)?.message,
        raiseError,
        notify
      )
    },
    onSuccess: () => {
      notify('success', t('success.editMaterial'))
    },
    onSettled: (data, error, variables) => {
      void settingsQueryClient.invalidateQueries({
        queryKey: [MaterialsQueryKey, variables.plantCode],
        refetchType: 'all'
      })
      void settingsQueryClient.invalidateQueries({
        queryKey: [MaterialWithRecipesQueryKey, variables.plantCode, variables.materialId],
        refetchType: 'all'
      })
    }
  })
}
